var map = {
	"./Authorize.json": "2198",
	"./AuthorizeResponse.json": "78fd",
	"./BootNotification.json": "c4cd",
	"./BootNotificationResponse.json": "22bf",
	"./CancelReservation.json": "1d6b",
	"./CancelReservationResponse.json": "93e0",
	"./ChangeAvailability.json": "3322",
	"./ChangeAvailabilityResponse.json": "9f6b",
	"./ChangeConfiguration.json": "0a28",
	"./ChangeConfigurationResponse.json": "c789",
	"./ClearCache.json": "86d4",
	"./ClearCacheResponse.json": "0727",
	"./ClearChargingProfile.json": "480d",
	"./ClearChargingProfileResponse.json": "bcb6",
	"./DataTransfer.json": "c2cd",
	"./DataTransferResponse.json": "41b5",
	"./DiagnosticsStatusNotification.json": "eb55",
	"./DiagnosticsStatusNotificationResponse.json": "6a16",
	"./FirmwareStatusNotification.json": "29a1",
	"./FirmwareStatusNotificationResponse.json": "3a89",
	"./GetCompositeSchedule.json": "4fa6",
	"./GetCompositeScheduleResponse.json": "9591",
	"./GetConfiguration.json": "87ed",
	"./GetConfigurationResponse.json": "af19",
	"./GetDiagnostics.json": "cad9",
	"./GetDiagnosticsResponse.json": "ddb9",
	"./GetLocalListVersion.json": "3b8c",
	"./GetLocalListVersionResponse.json": "0c43",
	"./Heartbeat.json": "54e6",
	"./HeartbeatResponse.json": "d747",
	"./MeterValues.json": "828a",
	"./MeterValuesResponse.json": "0ca5",
	"./RemoteStartTransaction.json": "a241",
	"./RemoteStartTransactionResponse.json": "030f",
	"./RemoteStopTransaction.json": "2a92",
	"./RemoteStopTransactionResponse.json": "75bb",
	"./ReserveNow.json": "369f",
	"./ReserveNowResponse.json": "b816",
	"./Reset.json": "a7cb",
	"./ResetResponse.json": "0e58",
	"./SendLocalList.json": "1019",
	"./SendLocalListResponse.json": "9aae",
	"./SetChargingProfile.json": "d7d0",
	"./SetChargingProfileResponse.json": "3415",
	"./StartTransaction.json": "a4a9",
	"./StartTransactionResponse.json": "6ced",
	"./StatusNotification.json": "3ad5",
	"./StatusNotificationResponse.json": "eab0",
	"./StopTransaction.json": "b9e7",
	"./StopTransactionResponse.json": "690b",
	"./TriggerMessage.json": "ce36",
	"./TriggerMessageResponse.json": "5113",
	"./UnlockConnector.json": "dc67",
	"./UnlockConnectorResponse.json": "3ed1",
	"./UpdateFirmware.json": "294e",
	"./UpdateFirmwareResponse.json": "cbce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "af40";